import React from 'react';
import { useNavigate } from 'react-router-dom';
import PaginatedUserTable from './UsersTable';

const UserDashboard = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-900 flex flex-col items-center justify-start p-8 text-white">
      {/* Encabezado */}
      <h1 className="text-4xl font-bold text-center text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-purple-200 mb-6">
        Panel de Usuarios
      </h1>

      {/* Botón para Crear Usuario */}
      <div className="w-full max-w-md mb-8">
        <button
          onClick={() => navigate('/user/create')}
          className="w-full px-6 py-3 bg-purple-600 rounded-lg hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-purple-500 text-white font-medium"
        >
          Crear Usuario
        </button>
      </div>

      {/* Tabla de Usuarios Paginada */}
      <div className="w-full md:max-w-3xl">
        <PaginatedUserTable />
      </div>
    </div>
  );
};

export default UserDashboard;